import { NavLink } from 'react-router-dom';
import './AdminSidebar.css';

const NAV_ITEMS = [
  { to: '/admin/dashboard', icon: '▦', label: 'Dashboard' },
  { to: '/admin/users', icon: '👤', label: 'Kullanıcılar' },
  { to: '/admin/notes', icon: '📄', label: 'Notlar' },
  { to: '/admin/matches', icon: '⇄', label: 'Eşleşmeler' },
  { to: '/admin/messages', icon: '💬', label: 'Mesajlar' },
  { to: '/admin/notifications', icon: '🔔', label: 'Bildirimler' },
  { to: '/admin/courses', icon: '📚', label: 'Ders Seçenekleri' },
  { to: '/admin/favorites', icon: '★', label: 'Favori İstatistikleri' },
  { to: '/admin/settings', icon: '⚙', label: 'Ayarlar' },
];

export default function AdminSidebar({ maintenanceMode, onSignOut }) {
  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar-brand">
        <div className="sidebar-logo">
          <span className="logo-note">Note</span><span className="logo-swapp">Swapp</span>
          <span className="sidebar-admin-badge">Admin</span>
        </div>
        <p className="sidebar-panel-label">Admin Panel</p>
      </div>

      <nav className="admin-sidebar-nav">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-bottom">
        <button className="sidebar-signout" onClick={onSignOut}>
          <span>↩</span> Çıkış Yap
        </button>
        <div className={`sidebar-status-badge${maintenanceMode ? ' maintenance' : ''}`}>
          <span className="status-dot" />
          {maintenanceMode ? 'Bakım Modu Aktif' : 'Uygulama Aktif'}
        </div>
      </div>
    </aside>
  );
}
